<template>
	<div class="newBounce">
		<div class="breadcrumb">APP首页弹框管理 >
			<span v-if="edit === false">新增</span>
			<span v-if="edit !== false">编辑</span>
			<span>
				<el-button class="right_f" type="primary" @click="cancel">取消</el-button>
				<el-button class="right_f" type="primary" @click="save">保存</el-button>
			</span>
		</div>

		<div class="detail">
			<el-form ref="bounceForm" :rules="rules" :model="bounceForm" label-width="130px">
				<el-form-item label="弹框名称:" prop="name">
					<el-input v-model="bounceForm.name" placeholder="名称仅用做后台管理，不会展现在APP上，选填" class="bounceTitle">
					</el-input>
				</el-form-item>
				<el-form-item label="弹框类型:" prop="bounceType" required>
					<el-select v-model="bounceForm.bounceType" class="bounceZhouqi">
						<el-option label="常规弹框" value="0">
						</el-option>
						<el-option label="不规则弹框" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="常规弹框图片" prop="imgUrl">
					<el-upload :action="actionUrl" :with-credentials='true' accept="image/*" name="uploadFile"
						type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess">
						<i class="el-icon-upload"></i>
						<div class="el-dragger__text">将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="不规则弹框图片" prop="irregularImgUrl" required v-if="bounceForm.bounceType=='1'">
					<el-upload :action="actionUrl" :with-credentials='true' accept="image/*" name="uploadFile"
						type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess_irreg">
						<i class="el-icon-upload"></i>
						<div class="el-dragger__text">将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>
				</el-form-item>
				<br>
				<el-form-item label="弹框主标题:" prop="mainTitle">
					<el-input v-model="bounceForm.mainTitle" class="bounceTitle" placeholder="请填写正确的主标题，不超过16个字符">
					</el-input>
				</el-form-item>
				<el-form-item label="弹框副标题:" prop="subTitle">
					<el-input v-model="bounceForm.subTitle" class="bounceTitle" placeholder="请填写正确的副标题，不超过48个字符">
					</el-input>
				</el-form-item>
				<el-form-item label="按钮文案:" prop="btnText">
					<el-input v-model="bounceForm.btnText" class="bounceTitle" placeholder="查看详情"></el-input>
				</el-form-item>
				<el-form-item label="弹出周期:" prop="showStatus">
					<el-select v-model="bounceForm.showStatus" class="bounceZhouqi">
						<el-option label="每天首次启动APP" value="1">
						</el-option>
						<el-option label="每次启动APP" value="2"></el-option>
						<el-option label=" 活动期间仅弹出一次" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告曝光代码:" prop="adExposingCodes" class="bounceContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="在这里粘贴"
						v-model="bounceForm.adExposingCodes">
					</el-input>
				</el-form-item>
				<el-form-item label="起止日期:" prop="qizhiDate" required>

					<el-form-item prop="startTime" class="time">
						<el-date-picker type="datetime" v-model="bounceForm.startTime" placeholder="yyyy/MM/dd hh:mm:ss"
							class="qizhiDate"></el-date-picker>
					</el-form-item>
					&nbsp;&nbsp;至&nbsp;&nbsp;
					<el-form-item prop="endTime" class="time">
						<el-date-picker type="datetime" v-model="bounceForm.endTime" class="qizhiDate"
							placeholder="yyyy/MM/dd hh:mm:ss"></el-date-picker>
					</el-form-item>
				</el-form-item>

				<el-form-item label="点击事件" prop="clickType" class="click-events">
					<el-radio v-model="bounceForm.clickType" label="0" style="margin-left:10px;">无跳转</el-radio>
					<el-radio v-model="bounceForm.clickType" label="1">跳转至URL：</el-radio>
					<el-radio v-model="bounceForm.clickType" label="2">跳转至已有文章：</el-radio>
					<el-radio v-model="bounceForm.clickType" label="3">跳转至已有话题：</el-radio>
					<el-radio v-model="bounceForm.clickType" label="5">跳转至微信小程序：</el-radio>
					<el-radio v-model="bounceForm.clickType" label="7">跳转至支付宝小程序：</el-radio>
					<el-radio v-model="bounceForm.clickType" label="6">跳转至音频：</el-radio>

					<el-input v-model="bounceForm.targetUrl" class="bounceTitle"
						v-if="shieldArray.indexOf(bounceForm.clickType) > -1" :placeholder="placeholder"></el-input>
				</el-form-item>
				<!-- 微信小程序 -->
				<div v-if="bounceForm.clickType == '5'" class="wx-app">
					<el-form-item label="小程序原始Id：" class="wxApp-from" required>
						<el-input v-model="bounceForm.wxAppId" placeholder="请填写正确的小程序原始Id"></el-input>
					</el-form-item>
					<el-form-item label="路径地址：" class="wxApp-from">
						<el-input v-model="bounceForm.wxAppUrl" placeholder="请填写正确的路径地址"></el-input>
					</el-form-item>
				</div>
				<!-- 支付宝小程序 -->
				<div v-if="bounceForm.clickType == '7'" class="wx-app">
					<el-form-item label="小程序原始Id：" class="wxApp-from" required>
						<el-input v-model="bounceForm.aliAppId" placeholder="请填写正确的小程序原始Id"></el-input>
					</el-form-item>
					<el-form-item label="路径地址：" class="wxApp-from">
						<el-input v-model="bounceForm.aliAppUrl" placeholder="请填写正确的路径地址"></el-input>
					</el-form-item>
				</div>

				<!-- 音频 -->
				<div v-if="bounceForm.clickType == '6'" class="wx-app">
					<el-form-item label="专辑ID：" class="wxApp-from" required>
						<el-input v-model="bounceForm.albumId" placeholder="请填写专辑ID"></el-input>
					</el-form-item>
					<el-form-item label="主播名称：" prop="nickName" class="wxApp-from wx-app" required>
						<el-input v-model="bounceForm.nickName" placeholder="请填写主播名称"></el-input>
					</el-form-item>
					<el-form-item label="单曲数：" class="wxApp-from" required>
						<el-input v-model="bounceForm.albumCount" placeholder="请填写单曲数" type="number"></el-input>
					</el-form-item>
					<el-form-item label="是否付费：" prop="isPaid" class="wxApp-from" required>
						<el-radio v-model="bounceForm.isPaid" label="1">是</el-radio>
						<el-radio v-model="bounceForm.isPaid" label="0">否</el-radio>
					</el-form-item>
				</div>

				<div v-if="['1', '5', '7'].indexOf(bounceForm.clickType) > -1" class="popup-prompt-wrap">
					<el-form-item label="是否弹窗提示" required>
						<div class="popup-prompt-row">
							<el-radio-group v-model="bounceForm.isPopup">
								<el-radio :label="0">否</el-radio>
								<el-radio :label="1">是</el-radio>
							</el-radio-group>
							<el-input
								v-if="bounceForm.isPopup === 1"
								v-model="bounceForm.popupContent"
								maxlength="20"
								placeholder="请填写弹窗内容，最多20个字"
								class="popup-prompt-input"
							></el-input>
							<div class="popup-prompt-example">
								<span class="popup-prompt-example-label">示例</span>
								<img :src="popupPromptExampleImg" alt="弹窗示例" />
							</div>
						</div>
					</el-form-item>
				</div>

				<select-school :schObj="bounceForm.schObj" :isRoot="isRoot" @changeVal="getVal"></select-school>

			</el-form>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { mapActions } from 'vuex'
	import selectSchool from "../../common/selectSch.vue"
	import popupPromptExampleImg from "../../../assets/popup-prompt-example.png"

	export default {
		data() {
			let checkStringNull = (rule, value, callback) => {
				if (value && value.trim()) {
					callback();
				} else {
					callback(new Error("输入不能为空"));
				}
			};

			return {
				actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=7',
				edit: false,
				isRoot: false,
				shieldArray: ['1', '2', '3'],
				popupPromptExampleImg,
				bounceForm: {
					name: "",
					bounceType: '0',
					label: "",
					imgUrl: "",
					irregularImgUrl: "",
					status: "0",
					mainTitle: "",
					subTitle: "",
					btnText: "查看详情",
					showStatus: "1",
					qizhiDate: "yyyy/mm/dd",
					adExposingCodes: "",
					startTime: "",
					endTime: "",
					clickType: "0",
					targetUrl: "",
					allUnidFlag: "1",
					id: "",
					wxAppId: '',
					wxAppUrl: '',
					aliAppId: '',
					aliAppUrl: '',
					schObj: {
						applicableCampus: "1",
						shieldedSchools: [], //屏蔽的学校
						openedSchools: []//应用的学校
					},
					albumId: "",
					nickName: "",
					albumCount: "",
					isPaid: '0',
					isPopup: 0,
					popupContent: ''
				},
				rules: {
					imgUrl: [
						{ required: true, message: '请上传弹框图片', trigger: 'change' }
					],
					name: [
						{ min: 1, max: 20, message: '请填写正确的名称,不超过20个字符', trigger: 'blur' },
					],
					mainTitle: [
						{ required: true, message: '请填写正确主标题', trigger: 'blur' },
						{ min: 1, max: 16, message: '不超过16个字符', trigger: 'blur' },
						{ validator: checkStringNull }
					],
					subTitle: [
						{ required: true, message: '请填写正确的副标题', trigger: 'blur' },
						{ min: 1, max: 48, message: '不超过48个字符', trigger: 'blur' },
						{ validator: checkStringNull }
					],
					btnText: [
						{ required: true, message: '请填写正确的按钮文案', trigger: 'change' },
						{ validator: checkStringNull }
					]
				}
			}
		},
		components: { selectSchool },
		watch: {
			'bounceForm.clickType'(val) {
				if (['1', '5', '7'].indexOf(val) === -1) {
					this.bounceForm.isPopup = 0;
					this.bounceForm.popupContent = '';
				}
			}
		},
		mounted() {

			let url = window.location.href;

			if (url.indexOf('?') !== -1) {
				this.edit = true;
				let bounceId = this.$util.getUrlParam('bounceId');
				this.getBounceDetail(bounceId);
			}
		},
		computed: {
			user() {
				return this.$store.state.user
			},
			placeholder() {
				if (this.bounceForm.clickType === '1') {
					return '请填写正确的URL地址'
				} else if (this.bounceForm.clickType === '2') {
					return '请填写正确的文章ID'
				} else {
					return '请填写正确的话题ID'
				}
			}

		},
		methods: {
			...mapActions(['SIGNOUT']),

			getVal(res) {
				this.bounceForm.schObj = res;
			},

			/**新增弹框**/
			add() {
				let startTime = new Date(this.bounceForm.startTime).format("yyyy-MM-dd hh:mm:ss");
				startTime = new Date(startTime);
				let endTime = new Date(this.bounceForm.endTime).format("yyyy-MM-dd hh:mm:ss");
				endTime = new Date(endTime);
				if (startTime.getTime() > endTime.getTime()) {
					this.$util.errorMsg("请填写正确的结束时间");
					return;
				}

				if (this.bounceForm.bounceType == "1" && !this.bounceForm.irregularImgUrl) {
					this.$util.errorMsg("请上传不规则弹框图片");
					return;
				}

				if (this.shieldArray.indexOf(this.bounceForm.clickType) > -1 && !this.bounceForm.targetUrl.trim()) {
					this.$util.errorMsg("点击事件的id或者url不能为空！");
					return;
				}

				if (this.bounceForm.clickType === '5' && !this.bounceForm.wxAppId.trim()) {
					this.$util.errorMsg("微信小程序的原始id不能为空！");
					return;
				}

				if (this.bounceForm.clickType === '5' && this.bounceForm.wxAppId.indexOf('id=') > -1) {
					this.$util.errorMsg("微信小程序的原始id输入格式错误！");
					return;
				}
				if (this.bounceForm.clickType === '7' && !this.bounceForm.aliAppId.trim()) {
					this.$util.errorMsg("支付宝小程序的原始id不能为空！");
					return;
				}

				if (this.bounceForm.clickType === '7' && this.bounceForm.aliAppId.indexOf('appId=') > -1) {
					this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
					return;
				}

				if (this.bounceForm.schObj.applicableCampus == '1' && this.bounceForm.schObj.openedSchools.length == 0) {
					this.$util.errorMsg("请添加应用学校");
					return;
				}

				let rootUnids = [], schObj = this.bounceForm.schObj;
				if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
					for (let i = 0; i < schObj.shieldedSchools.length; i++) {
						rootUnids.push({
							campusName: schObj.shieldedSchools[i].name,
							unid: schObj.shieldedSchools[i].rootUnid * 1
						})
					}
				} else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
					for (let i = 0; i < schObj.openedSchools.length; i++) {
						rootUnids.push({
							campusName: schObj.openedSchools[i].name,
							unid: schObj.openedSchools[i].rootUnid * 1
						})
					}
				}

				if (['1', '5', '7'].indexOf(this.bounceForm.clickType) > -1) {
					if (this.bounceForm.isPopup === 1 && !this.bounceForm.popupContent.trim()) {
						this.$util.errorMsg('请填写弹窗内容');
						return;
					}
				}

				if (this.bounceForm.clickType === '6') {
					var re = /^[0-9]+$/;
					if (!this.bounceForm.albumId.trim()) {
						this.$util.errorMsg("专辑ID不能为空！");
						return;
					}
					if (!this.bounceForm.nickName.trim()) {
						this.$util.errorMsg("主播名称不能为空！");
						return;
					}
					if (!this.bounceForm.albumCount || !re.test(this.bounceForm.albumCount)) {
						this.$util.errorMsg("单曲数输入有误！");
						return;
					}
				}

				if (this.bounceForm.clickType == '0') {
					this.bounceForm.targetUrl = '';
				} else if (this.bounceForm.clickType == '5') {
					// 微信小程序的id和url作为两个参数拼成字符串传给后台
					if (this.bounceForm.wxAppUrl && this.bounceForm.wxAppUrl.trim()) {
						this.bounceForm.targetUrl = 'id=' + this.bounceForm.wxAppId.trim() + '&path=' + this.bounceForm.wxAppUrl.trim();
					} else {
						this.bounceForm.targetUrl = 'id=' + this.bounceForm.wxAppId.trim();
					}
				} else if (this.bounceForm.clickType == '6') {
					this.bounceForm.targetUrl = 'id=' + this.bounceForm.albumId + '&nickName=' + this.bounceForm.nickName
						+ '&count=' + this.bounceForm.albumCount + '&isPaid=' + this.bounceForm.isPaid;
				} else if (this.bounceForm.clickType == '7') {
					// 支付宝小程序的id和url作为两个参数拼成字符串传给后台
					if (this.bounceForm.aliAppUrl && this.bounceForm.aliAppUrl.trim()) {
						this.bounceForm.targetUrl = 'appId=' + this.bounceForm.aliAppId.trim() + '&page=' + this.bounceForm.aliAppUrl.trim();
					} else {
						this.bounceForm.targetUrl = 'appId=' + this.bounceForm.aliAppId.trim();
					}
				}
				// 增加AppId入参的整理(过滤空格)
				let adExposingCodes = this.bounceForm.adExposingCodes.trim() || '',
					name = this.bounceForm.name.trim() || '',
					mainTitle = this.bounceForm.mainTitle.trim() || '',
					subTitle = this.bounceForm.subTitle.trim() || '',
					btnText = this.bounceForm.btnText.trim() || '';

				let isPopup = 0;
				let popupContent = '';
				if (['1', '5', '7'].indexOf(this.bounceForm.clickType) > -1) {
					isPopup = this.bounceForm.isPopup * 1;
					popupContent = isPopup === 1 ? this.bounceForm.popupContent.trim() : '';
				}

				let requestBody = {
					allUnidFlag: schObj.applicableCampus * 1,//0,全部校区；1，部分校区；
					startTime: startTime.getTime(),
					endTime: endTime.getTime(),
					name: this.bounceForm.name.trim(),
					bounceType: this.bounceForm.bounceType * 1,
					imgUrl: this.bounceForm.imgUrl,
					irregularImgUrl: this.bounceForm.irregularImgUrl,
					mainTitle: mainTitle,
					subTitle: subTitle,
					btnText: btnText,
					adExposingCodes: adExposingCodes,
					showStatus: this.bounceForm.showStatus * 1,
					clickType: this.bounceForm.clickType * 1,
					targetUrl: this.bounceForm.targetUrl,
					isPopup: isPopup,
					popupContent: popupContent,
					bounceCampusList: rootUnids
				};
				let url;
				if (this.edit) {
					requestBody.id = this.$util.getUrlParam('bounceId') * 1;
					url = this.$util.domain + '/adminapi/v1/operate/bounce/update';
				} else {
					url = this.$util.domain + '/adminapi/v1/operate/bounce/insert';
				}
				this.$http({
					url,
					method: 'POST',
					body: JSON.stringify(requestBody)
				}).then(response => {
					if (response.data.error === 10000) {
						location.href = '/#/yunying/bounce/bounceManage'
					} else {
						this.$util.errorMsg(response.data.message);
					}
				})

			},
			placeholder() {
				if (this.bounceForm.clickType === '1') {
					return '请填写正确的URL地址'
				} else if (this.bounceForm.clickType === '2') {
					return '请填写正确的文章ID'
				} else {
					return '请填写正确的话题ID'
				}
			},
			//***获取弹框详情**//
			getBounceDetail(id) {
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v1/operate/bounce/queryByBounceId?bounceId=' + id
				}).then((response) => {
					if (response.data.error === 10000) {
						let data = response.data.data;
						data.startTime = data.startTime.replace(/-/g, "/");
						data.endTime = data.endTime.replace(/-/g, "/");

						// 点击事件的ID或URL的整理
						let targetUrl = '', wxAppId = '', wxAppUrl = '', aliAppId = '', aliAppUrl = '', albumId, nickName, albumCount, isPaid = '0';
						if (data.clickType === 5) {
							// 微信小程序地址拆分
							wxAppId = this.$util.getUrlParam('id', data.targetUrl);
							wxAppUrl = this.$util.getUrlParam('path', data.targetUrl);
						} else if (data.clickType === 7) {
							// 支付宝小程序地址拆分
							aliAppId = this.$util.getUrlParam('appId', data.targetUrl);
							aliAppUrl = this.$util.getUrlParam('page', data.targetUrl);
							let query = this.$util.getUrlParam('query', data.targetUrl);
							if (query) {
								aliAppUrl = aliAppUrl + '&query=' + query;
							}
						} else if (data.clickType === 0) {
							targetUrl = '';
						} else if (data.clickType === 6) {
							albumId = this.$util.getUrlParam('id', data.targetUrl);
							nickName = this.$util.getUrlParam('nickName', data.targetUrl);
							albumCount = this.$util.getUrlParam('count', data.targetUrl);
							isPaid = this.$util.getUrlParam('isPaid', data.targetUrl);
						} else {
							targetUrl = data.targetUrl;
						}

						this.bounceForm = {
							name: data.name || '',
							imgUrl: data.imgUrl,
							irregularImgUrl: data.irregularImgUrl,
							bounceType: data.bounceType + "",
							startTime: data.startTime,
							mainTitle: data.mainTitle || '',
							subTitle: data.subTitle || '',
							btnText: data.btnText || '',
							qizhiDate: "yyyy/MM/dd",
							endTime: data.endTime,
							adExposingCodes: data.adExposingCodes || '',
							showStatus: (data.showStatus).toString(),
							clickType: (data.clickType).toString(),
							targetUrl: targetUrl ? targetUrl + '' : '',
							wxAppId: wxAppId,
							wxAppUrl: wxAppUrl,
							aliAppId: aliAppId,
							aliAppUrl: aliAppUrl,
							schObj: {
								shieldedSchools: [],
								openedSchools: [],
								applicableCampus: data.allUnidFlag ? data.allUnidFlag + "" : "0"
							},
							albumId: albumId,
							nickName: nickName,
							albumCount: albumCount,
							isPaid: isPaid,
							isPopup: data.isPopup != null ? data.isPopup * 1 : 0,
							popupContent: data.popupContent || ''
						};
						let schArray = data.bounceCampusList.map(item => { return { name: item.campusName, rootUnid: item.unid } });
						data.allUnidFlag == 0 ? (this.bounceForm.schObj.shieldedSchools = schArray) : (this.bounceForm.schObj.openedSchools = schArray);
					}
				})

			},
			//**保存**//
			save() {
				console.log(' ---------- this.bounceForm:', this.bounceForm)
				this.$refs.bounceForm.validate((valid) => {
					if (valid) {
						this.add();
					}
				})
			},
			/**
			 * 取消
			**/
			cancel() {
				history.go(-1);
			},
			/**
			*上传文件成功钩子
			**/
			handleSuccess(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg('上传失败');
				} else {
					this.bounceForm.imgUrl = response.data;
				}
			},
			handleSuccess_irreg(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg('上传失败');
				} else {
					this.bounceForm.irregularImgUrl = response.data;
				}
			},
			/**上传文件失败钩子**/
			handleError(response) {
				if (response.status === 403) {
					this.SIGNOUT();
					location.href = '/#';
				}

				this.$util.errorMsg('上传失败');
			}
		}
	}

</script>
<style>
	.inline {
		display: inline-block;
		margin-right: 20px;
		margin-bottom: 15px;
	}

	.btn_newBounce+.btn_newBounce {
		margin-left: 0;
	}

	.bounceTitle {
		width: 40%;
	}

	.newBounce .el-radio {
		display: block;
		width: 200px;
	}

	.newBounce .wxApp-from .el-radio {
		display: inline-block;
		width: 50px;
	}

	.newBounce .wxApp-from {
		margin-bottom: 10px;
		margin-left: 120px;
	}

	.newBounce .wxApp-from .el-input {
		width: 60%;
	}

	.bounceZhouqi {
		width: 20%;
	}

	.qizhiDate {
		display: inline-block;
		width: 100%;
	}

	.newBounce .time {
		display: inline-block;
		width: 15%;
	}
</style>


// WEBPACK FOOTER //
// newBounce.vue?a9370612